export default __webpack_public_path__ + "static/media/card1.f09172ae.png";